import { styled } from "styled-components";

export const CopyContainer = styled.div`
  height: 20px;
  padding-top: 3px;
  color: #fff;
  font-size: 12px;
  align-self: center;
  margin-left: 20px;
`;
